module.exports = __webpack_public_path__ + "img/easy-as-pie-pumpkin-pie.5aa20df0.jpg";